import { render, staticRenderFns } from "./AuthImage.vue?vue&type=template&id=3b2a8b4e&"
import script from "./AuthImage.vue?vue&type=script&lang=js&"
export * from "./AuthImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports